// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FlashMessage_wrapper__b5z18","view-type-success":"FlashMessage_view-type-success__3bibF","view-type-error":"FlashMessage_view-type-error__bmX7s"};